import { CombinedBranchSummary, CombinedSummary, TreeData } from "./types";

function convertCombinedSummaryToTreeData(combined: CombinedSummary): TreeData {
  const companies = combined
    ? Object.keys(combined).map((companyId: string) => {
        const company = combined[companyId];
        const branches = company.branches.map(
          (branch: CombinedBranchSummary) => {
            const result = { ...branch };
            if (!result.customers) {
              result.customers = [{ firstName: "Loading...", lastName: "" }];
            }
            return result;
          }
        );
        return {
          id: companyId,
          name: company.name,
          enabled: true,
          branches
        };
      })
    : [];
  companies.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
  return {
    companies
  };
}

export default convertCombinedSummaryToTreeData;
